/** What a manually classified corporate bank statement line represents. Always Sollapay's own money. */
export enum BankLineClassification {
  BANK_FEE = 'bank_fee',
  BANK_FEE_REFUND = 'bank_fee_refund',
  INTEREST_EARNED = 'interest_earned',
  COMPANY_TRANSFER_IN = 'company_transfer_in',
  COMPANY_TRANSFER_OUT = 'company_transfer_out'
}
